import {ServiceUsageType} from "@shared/Invoice/ServiceUsageType";

export function buildConsumedUsageGroupingKeyParts(item = {}) {
	switch (item?.serviceUsageType) {
		case ServiceUsageType.QUANTITY:
			return [
				item?.itemPriceCents || 0,
				item?.conversionFactor || 0,
			]
		case ServiceUsageType.QUANTITY_NUMBER:
			return [
				item?.itemPriceCents || 0,
				item?.conversionFactor || 0,
				item?.quantity || 0,
			]
		default:
			return []
	}
}

export function buildConsumedUsageGroupingKey(parts = []) {
	return parts.map(part => encodeURIComponent(String(part))).join("|")
}
